import gsap from 'gsap'

import {
  getScrollTriggerOptions,
  linesRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const collectionLandingDesktopRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const title = selector('[data-motion-title]')[0]
  const text = selector('[data-motion-text]')[0]
  const images = selector('[data-motion-image]')

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, 0)
  }

  let textAnimation: SharedAnimation
  if (text) {
    textAnimation = linesRevealAnimation(text, reverse)
    timeline.add(textAnimation.timeline, 0.1)
  }


  // Each image has its own ScrollTrigger since they are spread vertically
  const imageTimelines: gsap.core.Timeline[] = []
  images.forEach((image: HTMLElement) => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: image,
        once: !reverse,
        start: 'top 90%',
        markers: false,
        invalidateOnRefresh: true,
        toggleActions: `play none none ${reverse ? 'reverse' : 'none'}`
      }
    })
    tl.fromTo(
      image,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, ease: 'power2.out' }
    )
    imageTimelines.push(tl)
  })

  return () => {
    timeline.scrollTrigger?.kill()
    timeline.kill()

    imageTimelines.forEach((tl) => {
      tl.scrollTrigger?.kill()
      tl.kill()
    })

    titleAnimation?.revert()
    textAnimation?.revert()
  }
}
